import { PageProps } from 'gatsby';
import Layout from '../layout/Layout';
import React, { ReactNode } from 'react';

export default ({
    element,
    props,
}: {
    element: ReactNode;
    props: PageProps & { pageContext: { pageType: `generic` | `generic-v2` } };
}) => {
    // Wraps all V2 pages in a div with the Kite Evo25 theme
    if (props.pageContext?.pageType === `generic-v2`) {
        return (
            <div className="kite-theme kite-theme--evo25-white">
                <Layout>{element}</Layout>
            </div>
        );
    }
    // Otherwise, maintains the Kite Life Unlimited theme for all existing pages
    return <Layout>{element}</Layout>;
};
